import c from "moment";
import r from "./getTimezoneUtcOffsetDifference.mjs";
function u(f, e, o) {
  const t = c(o);
  return r(
    t,
    f
  ) ? f.clone().utcOffset(t.utcOffset(), e) : f;
}
export {
  u as default
};
